export const sendEnquiry = async (formRef: any) => {
    const payload: any = {};

    payload.formData = Object.fromEntries(new FormData(formRef));
    payload.clientId = process.env.REACT_APP_POSTMAN_CLIENT_ID;

    try {
        const response = await fetch(
            `${process.env.REACT_APP_POSTMAN_BASE_URL}/api/enquiry`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            },
        );

        const result = await response.json();
        console.log("Success:", result);
    } catch (error) {
        console.error("Error:", error);
    }
};
